import { useMemo } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useClientGetManagersQuery } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { lodash } from 'helpers';

export const useClientManagers = () => {
  const { data, loading, error: apolloError } = useClientGetManagersQuery();

  const error = useError(apolloError, false);

  const managers = useMemo(
    () =>
      lodash.compact(data?.managers?.list).map((admin) => ({
        id: admin.id,
        firstName: admin.firstName,
        lastName: admin.lastName,
        middleName: admin.middleName,
      })),
    [data?.managers?.list]
  );

  return {
    managers,
    loading,
    error,
  };
};
